module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_8023.37568cbe.png";